// Password requirements — live checklist of the minimum password policy.
// Self-contained: it auto-detects the form's password input and highlights each
// rule as it is satisfied, so the partial can be dropped into any user form
// without wiring it to the surrounding form controller.
import { Controller } from "stimulus";

const RULES = {
  length: (value) => value.length >= 12,
  lower: (value) => /[a-z]/.test(value),
  upper: (value) => /[A-Z]/.test(value),
  digit: (value) => /\d/.test(value),
  special: (value) => /[^A-Za-z0-9]/.test(value),
};

export default class extends Controller {
  static targets = ["item"];
  static values = { input: String };

  connect() {
    this.passwordInput = this.findInput();
    if (!this.passwordInput) return;
    this.refresh = this.refresh.bind(this);
    this.passwordInput.addEventListener("input", this.refresh);
    this.refresh();
  }

  disconnect() {
    if (this.passwordInput) this.passwordInput.removeEventListener("input", this.refresh);
  }

  // Prefer an explicit selector (data-password-requirements-input-value); otherwise
  // pick the form's password field, skipping the confirmation input.
  findInput() {
    if (this.hasInputValue) return document.querySelector(this.inputValue);
    const form = this.element.closest("form");
    if (!form) return null;
    const fields = [...form.querySelectorAll('input[type="password"]')];
    return fields.find((field) => !/confirmation/i.test(field.name)) || fields[0];
  }

  refresh() {
    const value = this.passwordInput.value;
    this.itemTargets.forEach((item) => {
      const rule = RULES[item.dataset.req];
      const met = Boolean(rule && rule(value));
      item.classList.toggle("text-[#4a6b3e]", met);
      item.classList.toggle("text-[#8a847d]", !met);

      const mark = item.querySelector(".pwd-req__mark");
      if (mark) {
        mark.classList.toggle("bg-[#4a6b3e]", met);
        mark.classList.toggle("border-[#4a6b3e]", met);
        mark.classList.toggle("text-white", met);
        mark.classList.toggle("border-[#b6b0a8]", !met);
      }

      const check = item.querySelector(".pwd-req__check");
      if (check) {
        check.classList.toggle("opacity-100", met);
        check.classList.toggle("opacity-0", !met);
      }
    });
  }
}
